export class CoreVector {
  static isVector2Valid(vector) {
    return !isNaN(vector.x) && !isNaN(vector.y) && isFinite(vector.x) && isFinite(vector.y);
  }
}
